// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { setCurrentPlace, setPlaces, setCategories, setBrands } from '../../redux/actionsCreators';
import Api from '../../api';
import type { DefaultStateType } from '../../redux/reducers';
import type { PlaceType, CategoryType, BrandType } from '../../api/types';

type Props = {
  children: React.Node,
  setCurrentPlace: (place: PlaceType) => void,
  setPlaces: (places: Array<PlaceType>) => void,
  setCategories: (categories: Array<CategoryType>) => void,
  setBrands: (brands: Array<BrandType>) => void,
};

class FetchWrapper extends React.Component<Props> {
  componentDidMount = () => {
    Api.places.getPlaces().then((places: Array<PlaceType>) => {
      const currentPlace = localStorage.getItem('currentPlace');

      if (!currentPlace) {
        const place = places.find(place => place.name.toLowerCase() === 'los angeles');

        if (place && window.location.pathname !== '/') {
          this.props.setCurrentPlace(place);
        }
      }

      this.props.setPlaces(places);
    });
    Api.categories.getCategories().then((categories: Array<CategoryType>) => this.props.setCategories(categories));
    Api.brands.getBrands().then((brands: Array<BrandType>) => this.props.setBrands(brands));
  };

  render() {
    return <React.Fragment>{this.props.children}</React.Fragment>;
  }
}

const mapStateToProps = (state: DefaultStateType): DefaultStateType => state;

const mapDispatchToProps = (dispatch: Function): Object => ({
  setCurrentPlace(currentPlace) {
    dispatch(setCurrentPlace(currentPlace));
  },

  setPlaces(places: Array<PlaceType>) {
    dispatch(setPlaces(places));
  },

  setCategories(categories: Array<CategoryType>) {
    dispatch(setCategories(categories));
  },

  setBrands(brands: Array<BrandType>) {
    dispatch(setBrands(brands));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FetchWrapper);



// WEBPACK FOOTER //
// ./src/helpers/FetchWrapper/index.js